import { BrandingImage, BrandingStyle } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from "components/shared/containers/PageLayoutContainer";
import React from "react";
import EDEStatementsMainNavView from "../EDEStatementsMainNavView";
import EDEStatementsPageFooterView from "../EDEStatementsPageFooterView";
import EDEStatementsPageHeaderView, { EDEStatementsMobilePageHeaderView } from "../EDEStatementsPageHeaderView";
import "./styles.css";
import { PageFooterView } from "components/shared";
import EDEStatementsEnrollmentPageFooterView from "../EDEStatementsEnrollmentPageFooterView";

/**
 * @function EDEStatementsEnrollmentPageContentView
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <EDEStatementsEnrollmentPageContentView>
 *  <LeftColumn />
 *  <RightColumn />
 * </EDEStatementsEnrollmentPageContentView>
 */
export default function EDEStatementsEnrollmentPageContentView(props) {
  const showEDEStatementsPageFooterView = props.showEDEStatementsPageFooterView != null
    ? props.showEDEStatementsPageFooterView
    : true;
  const showABI22PageFooterView = props.showABI22PageFooterView != null
    ? props.showABI22PageFooterView
    : false;

  return (
    <div className="ede-statements-enrollment-page-content-view flex-container flex-vertical">
        <BrandingStyle
          style={{ "backgroundColor": "ede_statement_headerbg_abi22" }}
          className="upper-header-wrapper flex-container flex-horizontal align-center">
            <div className={ `flex-width logo-container `}>
                <BrandingImage id="ede_statements_filogo_abi22" className="page-header-logo" />
            </div>
        </BrandingStyle>
        <PageLayoutContainer className={ "" }>
        { props.children }
        </PageLayoutContainer>
        { showABI22PageFooterView && <PageFooterView /> }
        { showEDEStatementsPageFooterView && <EDEStatementsEnrollmentPageFooterView /> }
    </div>
  );
}